import AxiosWrapper from "../../../../basecomp/base/AxiosWrapper";
import Logger from "../../../../basecomp/base/Logger";
import { Environment, AssetImagesUploaded } from "../../assets/Strings";
const environment = process.env.REACT_APP_ENV;
const { axiosGetCallWithToken, axiosPostCallWithToken, axiosDeleteCallWithToken } = AxiosWrapper;

export const ImageUpload = async (
  assetId,
  selectedImages,
  handleToastOpen
) => {
  const formData = new FormData();
  formData.append("asset_id", assetId);
  formData.append("environment", environment);
  for (let i = 0; i < selectedImages.length; i++) {
    formData.append("images", selectedImages[i]);
  }
  try {
    if (environment !== "Production") {
      return handleToastOpen("error", Environment);
    }
    const response = await axiosPostCallWithToken(
      `/asset_it/asset-images-upload`,
      formData
    );

    if (response.data.status >= 400) {
      handleToastOpen("error", response.data.message);
      return;
    }
    if (response) {
      await handleToastOpen("success", AssetImagesUploaded);
      // window.location.reload();
    }
  } catch (error) {
    Logger.printStackTrace("Error fetching data:", error);
    throw error;
  }
};

export const getLocalAndGlobalAssetImages = async (id) => {
  try {
    const response = await axiosGetCallWithToken(
      `/asset_it/asset-images?id=${id}`
    );
    return response;
  } catch (error) {
    Logger.printStackTrace(error);
    // Return a default structure to prevent undefined errors
    return { data: [] };
  }
};

export const deleteLocalAndGlobalAssetImages = async (id, imageLink) => {
  try {
    const response = await axiosDeleteCallWithToken(
      `/asset_it/asset-images-delete?asset_id=${encodeURIComponent(id)}&imageLink=${encodeURIComponent(imageLink)}`
    );
    return response;
  } catch (error) {
    Logger.printStackTrace(error);
    // Return false to indicate failure
    return false;
  }
};